import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { blogsData } from '../data/contentData';
import Header from './Header';

// const BlogPost = ({ persona }) => {
//   const { slug } = useParams();
//   const blog = blogsData.find((b) => b.slug === slug);

//   if (!blog) {
//     return (
//       <div className="min-h-screen bg-pure-black flex items-center justify-center">
//         <div className="text-center">
//           <h1 className="text-4xl text-pure-white mb-4">Blog Post Not Found</h1>
//           <Link to="/" className="text-apple-blue hover:underline">
//             Return Home
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//       transition={{ duration: 0.5 }}
//       className="min-h-screen bg-pure-black"
//     >
//       <Header onSearch={() => {}} searchQuery="" />

//       <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
//         <Link
//           to="/"
//           className="text-apple-blue hover:underline mb-8 inline-block"
//           data-testid="back-link"
//         >
//           ← Back to Home
//         </Link>

//         <motion.article
//           initial={{ y: 30, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           transition={{ delay: 0.2, duration: 0.5 }}
//           className="prose prose-invert prose-lg max-w-none"
//         >
//           <h1 className="text-5xl font-bold text-pure-white mb-4">{blog.title}</h1>
//           <div className="flex items-center space-x-4 text-gray-400 mb-8">
//             <span>{blog.date}</span>
//             {blog.tags && (
//               <div className="flex space-x-2">
//                 {blog.tags.map((tag, i) => (
//                   <span key={i} className="text-xs bg-apple-blue/20 text-apple-blue px-2 py-1 rounded">
//                     {tag}
//                   </span>
//                 ))}
//               </div>
//             )}
//           </div>

//           <div className="text-gray-300 leading-relaxed">
//             <ReactMarkdown remarkPlugins={[remarkGfm]}>{blog.content}</ReactMarkdown>
//           </div>
//         </motion.article>
//       </div>
//     </motion.div>
//   );
// };

// export default BlogPost;



const BlogPost = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-pure-black"
    >
      <Header onSearch={() => {}} searchQuery="" />

      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="text-center">
          <h1 className="text-4xl text-pure-white mb-4">
            Blog temporarily disabled
          </h1>
          <Link to="/" className="text-apple-blue hover:underline">
            Return Home
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default BlogPost;


